import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useLocalizeModel } from "@/i18n/useLocalizeModel";

export default function ModelCard({ model: raw, large = false }) {
  const { t } = useTranslation();
  const localize = useLocalizeModel();
  const model = localize(raw);
  return (
    <motion.div whileHover={{ y: -4 }} transition={{ type: "spring", stiffness: 300, damping: 30 }}>
      <Link
        to={`/modelle/${model.slug}`}
        data-testid={`model-card-${model.slug}`}
        className="group block border border-slate-200 bg-white overflow-hidden h-full"
      >
        <div className={`overflow-hidden bg-[#EAF0F6] ${large ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
          <img
            src={model.image}
            alt={model.name}
            loading="lazy"
            style={model.image_position ? { objectPosition: model.image_position } : undefined}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </div>
        <div className="p-6 md:p-8">
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-slate-500">{model.category}</p>
            <span className="text-xs font-semibold px-2 py-1 border border-slate-200 text-slate-600"
                  data-testid={`model-status-${model.slug}`}>{model.status}</span>
          </div>
          <h3 className="mt-2 text-2xl md:text-3xl font-bold tracking-tight text-[#0A2540]">{model.name}</h3>
          <p className="mt-2 text-sm md:text-base text-slate-600 leading-relaxed">{model.tagline}</p>
          <div className="mt-5 flex items-center justify-between">
            <span className="text-sm font-semibold text-[#0A2540]" data-testid={`model-price-${model.slug}`}>
              {model.price_text}
            </span>
            <span className="flex items-center gap-1.5 text-sm font-semibold text-[#0052CC]">
              {t("showcase.discover")} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
